import React from 'react';

function LeftSideLayoutFinanceiro() {
  return <></>;
}

export default LeftSideLayoutFinanceiro;
